module.exports = __webpack_public_path__ + "img/zynga_poker.091b01a1.jpg";